module.exports = __webpack_public_path__ + "static/media/320px.07bf1839.png";